import { ProgressCircle, Text } from '@react-spectrum/s2';
import AlertTriangle from '@react-spectrum/s2/icons/AlertTriangle';
import Calendar from '@react-spectrum/s2/icons/Calendar';
import Checkmark from '@react-spectrum/s2/icons/Checkmark';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };
import type { ReactNode } from 'react';

export type ContentDetailStatusKind =
	| 'processing'
	| 'scheduled'
	| 'unconfirmed'
	| 'past_due'
	| 'published'
	| 'failed';

interface ContentDetailStatusCalloutProps {
	status: ContentDetailStatusKind;
	label: string;
	progressAriaLabel: string;
	// A node, not a string, so a caller can put a link in the detail line.
	detail?: ReactNode;
	trailing?: ReactNode;
}

export const ContentDetailStatusCallout = ({
	status,
	label,
	progressAriaLabel,
	detail,
	trailing,
}: ContentDetailStatusCalloutProps) => (
	<div className="glass-card-sm flex flex-col gap-2 px-4 py-3">
		<div className="flex flex-wrap items-center gap-3">
			<span className="inline-flex min-w-0 flex-1 items-center gap-2">
				<span
					className="inline-flex h-[18px] w-[18px] shrink-0 items-center
						justify-center"
				>
					{status === 'processing' ? (
						<ProgressCircle
							size="S"
							isIndeterminate
							aria-label={progressAriaLabel}
						/>
					) : status === 'published' ? (
						<Checkmark />
					) : status === 'failed' || status === 'past_due' ? (
						<AlertTriangle />
					) : (
						<Calendar />
					)}
				</span>
				<Text
					styles={style({
						font: 'body',
						fontSize: 'body',
						color: 'body',
					})}
				>
					{label}
				</Text>
			</span>
			{trailing}
		</div>
		{detail && (
			<div className="flex flex-col gap-2">
				<hr className="border-gray-200" />
				<Text
					styles={style({
						font: 'body',
						fontSize: 'body',
						color: 'gray-600',
					})}
				>
					{detail}
				</Text>
			</div>
		)}
	</div>
);
